import React from "react";
import { ArrayField, Datagrid, EditButton, List, ShowButton, TextField } from "react-admin";
import { EmptyList } from "../../../../common/components";
import { catalogFilter } from "../../Partials/Filters";
import { CreateActions } from "../../../../utils/customActions";
import { settings } from "app";

const ListCatalog = () => {
  return (
    <List
      sort={{ field: "id", order: "DESC" }}
      actions={<CreateActions />}
      filters={catalogFilter}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="Заглавие"
          source="title"
          sortable={false}
        />
        <TextField
          label="Каталожен номер"
          source="catalog_number"
          sortable={false}
        />
        <TextField
          label="Вид издание"
          source="edition_type"
          sortable={false}
        />

        <ArrayField
          label="Абонаменти"
          source="subscriptions_prices"
          sortable={false}
        >
          <Datagrid
            sx={settings.nestedDatagridStyle}
            bulkActionButtons={false}
          >
            <TextField
              label="За брой месеци"
              source="month_index"
              sortable={false}
            />
            <TextField
              label="Цена в лв."
              source="price"
              sortable={false}
            />
          </Datagrid>
        </ArrayField>
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default ListCatalog;
